export default Object.freeze({
  admin: [
    {
      icon: "mdi-account-box-outline",
      key: "adminmenu.profile",
      text: "내정보",
    },
    {
      icon: "mdi-shield-key-outline",
      key: "adminmenu.changePassword",
      text: "비밀번호변경",
    },
    {
      icon: "mdi-palette",
      key: "adminmenu.theme",
      text: "테마",
    },
  ],
});
